import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './routes/PrivateRoute';

import LoginPage    from './pages/auth/LoginPage';
import Dashboard    from './pages/superadmin/Dashboard';
import ManageOwners from './pages/superadmin/ManageOwners';
import ManageAdmins from './pages/superadmin/ManageAdmins';
import KYCManagement from './pages/superadmin/KYCManagement';
import ViewGroups   from './pages/superadmin/ViewGroups';
import ViewMembers  from './pages/superadmin/ViewMembers';
import SystemStats  from './pages/superadmin/SystemStats';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Toaster
          position="top-right"
          toastOptions={{
            style: { borderRadius: '12px', fontFamily: 'Inter, sans-serif', fontSize: '14px' },
            success: { iconTheme: { primary: '#2563eb', secondary: '#fff' } },
          }}
        />
        <Routes>
          {/* Public */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected — SuperAdmin only */}
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/kyc"       element={<KYCManagement />} />
            <Route path="/admins"    element={<ManageAdmins />} />
            <Route path="/owners"    element={<ManageOwners />} />
            <Route path="/groups"    element={<ViewGroups />} />
            <Route path="/members"   element={<ViewMembers />} />
            <Route path="/stats"     element={<SystemStats />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
